import React from 'react';

import { theme } from '../../../../tailwind.config';
import { IIconProps } from 'ui/CircleIconButton';

export const StarHalfFilledIcon: React.FC<IIconProps> = React.memo(
  ({ fill = theme.colors['brown-100'], background = 'transparent' }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ backgroundColor: background }}
    >
      <path
        d="M12 0.999984C12.163 1.0006 12.3233 1.04134 12.4669 1.1186C12.6104 1.19586 12.7327 1.30727 12.823 1.44298L12.89 1.55898L15.742 7.33998L22.122 8.26498C22.863 8.37298 23.202 9.20498 22.825 9.79098L22.755 9.88598L22.677 9.97198L18.053 14.471L19.143 20.826C19.1714 20.9918 19.1576 21.162 19.1028 21.321C19.048 21.48 18.954 21.6227 18.8296 21.7358C18.7051 21.8489 18.5541 21.9288 18.3906 21.9682C18.2271 22.0075 18.0563 22.0051 17.894 21.961L17.793 21.926L17.692 21.88L11.999 18.88L6.293 21.88C6.188 21.935 6.081 21.97 5.973 21.986L5.867 21.996C5.72743 22.0011 5.58834 21.977 5.45862 21.9252C5.32891 21.8735 5.21143 21.7952 5.11372 21.6954C5.016 21.5956 4.9402 21.4765 4.89118 21.3458C4.84215 21.215 4.82097 21.0754 4.829 20.936L4.842 20.826L5.932 14.471L1.309 9.97098C1.18945 9.85454 1.10092 9.71006 1.05144 9.55068C1.00197 9.3913 0.993123 9.22208 1.02572 9.05841C1.05831 8.89474 1.13131 8.74181 1.23807 8.61355C1.34483 8.48528 1.48197 8.38574 1.637 8.32398L1.75 8.28798L1.864 8.26498L8.243 7.33998L11.096 1.55998C11.1756 1.38859 11.3036 1.24424 11.4642 1.14473C11.6249 1.04522 11.8111 0.994904 12 0.999984ZM12 4.27398V16.75C12.0805 16.75 12.1608 16.7597 12.239 16.779L12.354 16.815L12.466 16.865L16.829 19.164L15.993 14.291C15.9518 14.0502 16.0002 13.8026 16.129 13.595L16.199 13.496L16.281 13.406L19.827 9.95298L14.936 9.24498C14.6943 9.20989 14.4737 9.08753 14.316 8.90098L14.243 8.80398L14.183 8.69798L12 4.27398Z"
        fill={fill}
      />
    </svg>
  )
);

export default StarHalfFilledIcon;
